import { render, staticRenderFns } from "./base.vue?vue&type=template&id=fa87f766&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87f766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa87f766')) {
      api.createRecord('fa87f766', component.options)
    } else {
      api.reload('fa87f766', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=fa87f766&scoped=true", function () {
      api.rerender('fa87f766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/base.vue"
export default component.exports